/** MA Ribbon Cloud ATR — option + NIFTY index trade levels for UI. */

export const MA_RIBBON_STRATEGY_TYPE = 'ma_ribbon_cloud_atr';

export function isMaRibbonSignal(signal) {
  return String(signal?.strategy_type || '').trim() === MA_RIBBON_STRATEGY_TYPE;
}

function toNum(v) {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function extractMaRibbonIndexMap(signal) {
  if (!signal || typeof signal !== 'object') return {};
  const conditions = signal.conditions_met && typeof signal.conditions_met === 'object'
    ? signal.conditions_met
    : {};
  const raw =
    signal.ma_ribbon_index_targets
    || signal.ma_ribbon_targets
    || conditions.ma_ribbon_index_targets
    || conditions.ma_ribbon_targets
    || {};
  return typeof raw === 'object' && raw !== null ? raw : {};
}

export function extractMaRibbonOptionMap(signal) {
  if (!signal || typeof signal !== 'object') return {};
  const conditions = signal.conditions_met && typeof signal.conditions_met === 'object'
    ? signal.conditions_met
    : {};
  const raw = signal.ma_ribbon_option_targets || conditions.ma_ribbon_option_targets || {};
  return typeof raw === 'object' && raw !== null ? raw : {};
}

/** Resolve MA Ribbon option + index levels (same shape as Signal History trade details). */
export function getMaRibbonTradeLevels(signal) {
  const opt = extractMaRibbonOptionMap(signal);
  const idx = extractMaRibbonIndexMap(signal);

  const entry = toNum(signal?.entry_price) ?? toNum(opt.entry);
  const target1 = toNum(signal?.target_1) ?? toNum(opt.tp1);
  const target2 = toNum(signal?.target_2) ?? toNum(opt.tp2);
  const target3 = toNum(signal?.target_3) ?? toNum(opt.tp3);
  const stopLoss = toNum(signal?.stop_loss) ?? toNum(opt.stop_loss);

  return {
    entry,
    target1,
    target2,
    target3,
    stopLoss,
    indexEntry: toNum(signal?.index_entry) ?? toNum(idx.entry),
    indexStopLoss: toNum(signal?.index_stop_loss) ?? toNum(idx.stop_loss),
    indexTarget1: toNum(signal?.index_target_1) ?? toNum(idx.tp1),
    indexTarget2: toNum(signal?.index_target_2) ?? toNum(idx.tp2),
    indexTarget3: toNum(signal?.index_target_3) ?? toNum(idx.tp3),
  };
}

/** Option price with optional NIFTY index sub-line (Signal History style). */
export function formatMaRibbonPriceWithIndex(optionPrice, indexPrice) {
  if (optionPrice === null || optionPrice === undefined) {
    return { primary: 'N/A', indexLine: null };
  }
  const primary = `₹${Number(optionPrice).toFixed(2)}`;
  const indexLine =
    indexPrice !== null && indexPrice !== undefined
      ? `NIFTY: ₹${Number(indexPrice).toFixed(2)}`
      : null;
  return { primary, indexLine };
}
